<div class="app-menu navbar-menu">
	<div class="navbar-brand-box">
		<a routerLink="/dashboard" class="cis-brand">
			<span class="cis-brand__icon" aria-hidden="true">
				<i class="bx bx-store"></i>
			</span>
			<span class="cis-brand__name">
				<span class="cis-brand__title">E-Commerce</span>
				<span class="cis-brand__subtitle">Management</span>
				<span class="cis-brand__badge cis-brand__badge--portal">Admin Portal</span>
			</span>
		</a>
		<button type="button" class="btn btn-sm p-0 fs-20 header-item btn-vertical-sm-hover" id="vertical-hover">
			<i class="ri-record-circle-line"></i>
		</button>
	</div>

	<div id="scrollbar">
		<div class="container-fluid">
			<div id="two-column-menu">
			</div>

			<ul class="navbar-nav" id="navbar-nav">
				<li class="menu-title"><i class="ri-more-fill"></i> <span>Overview</span></li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/dashboard"
						[class.active]="isMenuActive('/dashboard', true)"
						[class.cis-menu-active]="isMenuActive('/dashboard', true)">
						<i class="bx bx-grid-alt"></i> <span data-key="t-widgets">Dashboard</span>
					</a>
				</li>

				<li class="menu-title"><i class="ri-more-fill"></i> <span>Administration</span></li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/system-user/list"
						[class.active]="isMenuActive('/system-user')"
						[class.cis-menu-active]="isMenuActive('/system-user')">
						<i class="bx bx-user"></i> <span data-key="t-widgets">System Users</span>
					</a>
				</li>

				<li class="menu-title"><i class="ri-more-fill"></i> <span>ECOMM management</span></li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/brands"
						[class.active]="isMenuActive('/ecomm/brands')"
						[class.cis-menu-active]="isMenuActive('/ecomm/brands')">
						<i class="bx bx-tag"></i> <span>Brands</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/categories"
						[class.active]="isMenuActive('/ecomm/categories')"
						[class.cis-menu-active]="isMenuActive('/ecomm/categories')">
						<i class="bx bx-category"></i> <span>Categories</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/sap-categories"
						[class.active]="isMenuActive('/ecomm/sap-categories')"
						[class.cis-menu-active]="isMenuActive('/ecomm/sap-categories')">
						<i class="bx bx-category-alt"></i> <span>SAP Categories</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/products"
						[class.active]="isMenuActive('/ecomm/products')"
						[class.cis-menu-active]="isMenuActive('/ecomm/products')">
						<i class="bx bx-package"></i> <span>Products</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/discounts"
						[class.active]="isMenuActive('/ecomm/discounts')"
						[class.cis-menu-active]="isMenuActive('/ecomm/discounts')">
						<i class="bx bx-purchase-tag-alt"></i> <span>Discounts</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/corporate-deals"
						[class.active]="isMenuActive('/ecomm/corporate-deals')"
						[class.cis-menu-active]="isMenuActive('/ecomm/corporate-deals')">
						<i class="bx bx-buildings"></i> <span>Corporate Deals</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link menu-link" routerLink="/ecomm/add-ons"
						[class.active]="isMenuActive('/ecomm/add-ons')"
						[class.cis-menu-active]="isMenuActive('/ecomm/add-ons')">
						<i class="bx bx-plus-circle"></i> <span>Add-Ons</span>
					</a>
				</li>
			</ul>
		</div>
	</div>

	<div class="sidebar-background"></div>
</div>
